import React from "react";
var __jsx = React.createElement;
import stl from "./BuyItWeDeliverIt.module.css";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
var BuyItWeDeliverIt = function BuyItWeDeliverIt() {
  var _useTranslation = useTranslation(["web_city"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.CB_container
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.CB_textContainer
  }, /*#__PURE__*/React.createElement("h2", null, t("اشتريها و نوصلها لباب بيتك", {
    ns: "web_city"
  })), /*#__PURE__*/React.createElement("p", null, t("من خلال شاحنات شركة سيارة الحديثة نوفر خدمات إيصال السيارة المراد شرائها لين باب بيتك لضمان الراحة الكاملة التي نسعى لتوفيرها في أي مكان داخل حدود المملكة العربية السعودية", {
    ns: "web_city"
  }))), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/city/buy_it_we_deliver_it.webp",
    alt: "buy it and we deliver it image",
    loading: "lazy",
    width: "450px",
    height: "200px"
  })));
};
export default BuyItWeDeliverIt;